const targetMain = () => import('@/views/main/target/main-target/main-target.vue')
export default {
  path: '/main/target/targetMain',
  name: 'targetMain',
  component: targetMain,
  children: []
}
